import { useAppSelector } from "@/state/hooks";
import { KYC_TYPE } from "@/constants/kyc";
import { useMemo } from "react";

const useHooks = () => {
  const userInfo = useAppSelector((state) => state.user.userInfo);

  const maxApiKeyNum = 5;

  const maxCreateAccountNum = useMemo(() => {
    if (userInfo.kyc_type === KYC_TYPE.UNAUTHORIZED) {
      return 0;
    } else if (userInfo.kyc_type === KYC_TYPE.PERSONAL) {
      return 5;
    } else {
      return 10;
    }
  }, [userInfo]);

  return {
    maxCreateAccountNum,
    maxApiKeyNum,
  };
};

export { useHooks };
